var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('span',{staticClass:"aaa"},[_vm._v("404")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"bbb"},[_vm._v("网站正在维护中...请稍后访问 ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73755459","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notfound.vue
// module id = null
// module chunks = 